import * as React from "react";

import { useAppSelector } from "../../../store/hooks";

import { formatNumberThousands } from "../../../utils";

import wallet from "../../../assets/img/common/wallet.svg";

const Wallet: React.FC = () => {
  const credit = useAppSelector((state) => state.config.balance);
  const currency = useAppSelector((state) => state.config.currency);

  return (
    <div className="wallet">
      <img src={wallet} alt="" />
      <p>
        {currency} {formatNumberThousands(credit)}
      </p>
    </div>
  );
};

export default Wallet;
